var classes = {"overlayMenuLinks":"_4jPFa","overlayMenuCategoryLinksCTA":"hdex4","overlayMenuLinksNoMargin":"_-6Bhq","overlayMenuCategoryLinksLink":"O8QYI","overlayMenuLinksList":"_0Y07-","overlayMenuCategoryLinksTitleLink":"W9te5","overlayMenuCategoryLinksTitleLinkCTA":"cG53K","overlayMenuCategoryLinksLinkComponent":"K29q-"};

export { classes as default };
